// extracted by mini-css-extract-plugin
export default {"container":"ZL-z","topReviewHeading":"_L-z","criticalReview":"aM-z","favorableReview":"bM-z","vsSeparator":"cM-z"};